import { SowInput, SowSelect } from './ValidationFields';
import type { SowAccountContact, SowPersonBlock } from '../../types';

interface Props {
  label: string;
  name: string;
  value: SowPersonBlock;
  onChange: (next: SowPersonBlock) => void;
  /** Offer a "fill from account contact" picker (supervisor / HR sponsor). */
  contacts?: SowAccountContact[];
  showTitle?: boolean;
}

/**
 * One person block of the SOW overview table: name / title / email / phone,
 * optionally seedable from the account's Salesforce contacts.
 */
export function PersonFields({ label, name, value, onChange, contacts, showTitle = true }: Props): JSX.Element {
  const set = (patch: Partial<SowPersonBlock>) => onChange({ ...value, ...patch });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <label className="input-label" style={{ marginBottom: 0 }}>{label}</label>
        {contacts && contacts.length > 0 && (
          <SowSelect
            className="select"
            style={{ maxWidth: 220, fontSize: 12 }}
            value=""
            onChange={(e) => {
              const c = contacts.find((x) => x.id === e.target.value);
              if (c) {
                onChange({
                  name: c.name ?? '',
                  title: c.title ?? '',
                  email: c.email ?? '',
                  phone: c.phone ?? '',
                });
              }
            }}
          >
            <option value="">Fill from account contact…</option>
            {contacts.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
                {c.title ? ` — ${c.title}` : ''}
              </option>
            ))}
          </SowSelect>
        )}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: showTitle ? '1fr 1fr' : '1fr', gap: 8 }}>
        <SowInput className="input" placeholder="Name" name={`${name}.name`} value={value.name} onChange={(e) => set({ name: e.target.value })} />
        {showTitle && (
          <SowInput className="input" placeholder="Title" name={`${name}.title`} value={value.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
        )}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
        <SowInput className="input" placeholder="Email" name={`${name}.email`} value={value.email} onChange={(e) => set({ email: e.target.value })} />
        <SowInput className="input" placeholder="Phone" name={`${name}.phone`} value={value.phone} onChange={(e) => set({ phone: e.target.value })} />
      </div>
    </div>
  );
}
